import { ChevronLeftIcon, ChevronRightIcon, EyeIcon, SearchIcon } from '@heroicons/react/outline'
import React, { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { getTransactions } from '../Redux/Action/order.action';
import { Backdrop, CircularProgress, Pagination } from '@mui/material';
import { FormatAmount, formatDate } from '../Controllers/FormatAmount';
import { CaretDownFill, CaretUpFill } from 'react-bootstrap-icons';
import { useSearchParams } from 'react-router-dom';

const TransactionList = ({ filter, setFilter, handleGetOrderData }) => {
    const dispatch = useDispatch();
    const { transactions, transactionsLoader, returnProductLoader } = useSelector((state) => state.orderReducer)
    const { staffInfo } = useSelector((state) => state?.authReducer)
    const [Page, setPage] = useState(1);
    const [limit, setLimit] = useState(25);
    const [search, setSearch] = useState();
    const [sortBy, setSortBy] = useState('');
    const [iconVisible, setIconVisible] = useState(false);
    const [orderBy, setOrderBy] = useState({ orderByValue: 'DESC', isDecending: false });
    const [searchParams] = useSearchParams();
    const customerId = searchParams.get('customer_id');
    var startRecord = (transactions?.data?.currentPage - 1) * limit + 1;
    var endRecord = Math.min(
        transactions?.data?.currentPage * limit,
        transactions?.data?.totalRecords,
    );
    const SortData = () => {
        if (!orderBy.isDecending) {
            setOrderBy({ orderByValue: 'DESC', isDecending: true });
        } else {
            setOrderBy({ orderByValue: 'ASC', isDecending: false });
        }
    };
    useEffect(() => {
        dispatch(getTransactions('', Page, limit, search, sortBy, orderBy?.orderByValue, filter, customerId))
    }, [search, Page, filter, orderBy, customerId])
    return (
        <>
            {transactionsLoader || returnProductLoader && <Backdrop
                sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 }}
                open={transactionsLoader || returnProductLoader}
                className='flex flex-col'
            >
                <CircularProgress color='inherit' />
                <p>Loading...</p>
            </Backdrop>}
            <div className='flex flex-wrap gap-2 items-center justify-end'>
                <div className='relative flex-grow'>
                    <SearchIcon className='input-icon w-5 h-5' />
                    <input type='text' placeholder='Search Order by Order Id...' value={search} onChange={(e) => setSearch(e.target.value)} className='!pl-10 w-full' />
                </div>
                <button className='square-btn'><svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" className="size-6">
                    <path strokeLinecap="round" strokeLinejoin="round" d="M3.75 4.875c0-.621.504-1.125 1.125-1.125h4.5c.621 0 1.125.504 1.125 1.125v4.5c0 .621-.504 1.125-1.125 1.125h-4.5A1.125 1.125 0 0 1 3.75 9.375v-4.5ZM3.75 14.625c0-.621.504-1.125 1.125-1.125h4.5c.621 0 1.125.504 1.125 1.125v4.5c0 .621-.504 1.125-1.125 1.125h-4.5a1.125 1.125 0 0 1-1.125-1.125v-4.5ZM13.5 4.875c0-.621.504-1.125 1.125-1.125h4.5c.621 0 1.125.504 1.125 1.125v4.5c0 .621-.504 1.125-1.125 1.125h-4.5A1.125 1.125 0 0 1 13.5 9.375v-4.5Z" />
                    <path strokeLinecap="round" strokeLinejoin="round" d="M6.75 6.75h.75v.75h-.75v-.75ZM6.75 16.5h.75v.75h-.75v-.75ZM16.5 6.75h.75v.75h-.75v-.75ZM13.5 13.5h.75v.75h-.75v-.75ZM13.5 19.5h.75v.75h-.75v-.75ZM19.5 13.5h.75v.75h-.75v-.75ZM19.5 19.5h.75v.75h-.75v-.75ZM16.5 16.5h.75v.75h-.75v-.75Z" />
                </svg>
                </button>
                <button className='square-btn'>
                    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" className="size-6">
                        <path strokeLinecap="round" strokeLinejoin="round" d="M12 3c2.755 0 5.455.232 8.083.678.533.09.917.556.917 1.096v1.044a2.25 2.25 0 0 1-.659 1.591l-5.432 5.432a2.25 2.25 0 0 0-.659 1.591v2.927a2.25 2.25 0 0 1-1.244 2.013L9.75 21v-6.568a2.25 2.25 0 0 0-.659-1.591L3.659 7.409A2.25 2.25 0 0 1 3 5.818V4.774c0-.54.384-1.006.917-1.096A48.32 48.32 0 0 1 12 3Z" />
                    </svg>
                </button>
                <div className='select-wrapper'>
                    <select value={filter} onChange={(e) => setFilter(e.target.value)}>
                        <option>All</option>
                        <option>Today</option>
                        <option>Yesterday</option>
                        <option>This Week</option>
                        <option>Last Week</option>
                        <option>This Month</option>
                        <option>Last Month</option>
                    </select>
                </div>
            </div>
            {transactions?.data?.records?.length > 0 ?
                <div className='rounded-[10px] overflow-auto border border-color'>
                    <table className='w-full'>
                        <thead>
                            <tr>
                                <td>Order id</td>
                                <td>
                                    <button
                                        type='button'
                                        className={`${iconVisible && sortBy === 'order_date' ? 'text-gray-700' : ''}`}
                                        onMouseEnter={() => {
                                            setIconVisible(true);
                                            setSortBy('order_date');
                                        }}
                                        onMouseLeave={() => {
                                            setIconVisible(false);
                                            setSortBy('');
                                        }}
                                        onClick={() => SortData('order_date')}
                                    >
                                        <div className='flex items-center'>
                                            Date {iconVisible && sortBy === 'order_date' ? (
                                                !orderBy.isDecending ? (
                                                    <CaretUpFill className='ms-2' />
                                                ) : (
                                                    <CaretDownFill className='ms-2' />
                                                )
                                            ) : (
                                                <></>
                                            )}
                                        </div>
                                    </button>
                                </td>
                                <td>Qty</td>
                                <td>
                                    <button
                                        type='button'
                                        className={`${iconVisible && sortBy === 'total_price' ? 'text-gray-700' : ''}`}
                                        onMouseEnter={() => {
                                            setIconVisible(true);
                                            setSortBy('total_price');
                                        }}
                                        onMouseLeave={() => {
                                            setIconVisible(false);
                                            setSortBy('');
                                        }}
                                        onClick={() => SortData('total_price')}
                                    >
                                        <div className='flex items-center'>
                                            price
                                            {iconVisible && sortBy === 'total_price' ? (
                                                !orderBy.isDecending ? (
                                                    <CaretUpFill className='ms-2' />
                                                ) : (
                                                    <CaretDownFill className='ms-2' />
                                                )
                                            ) : (
                                                <></>
                                            )}
                                        </div>
                                    </button>
                                </td>
                                <td>customer</td>
                                <td className='w-full text-right'>Return status</td>
                                <td className='w-full text-right'>
                                    <button
                                        type='button'
                                        className={`${iconVisible && sortBy === 'status' ? 'text-gray-700' : ''}`}
                                        onMouseEnter={() => {
                                            setIconVisible(true);
                                            setSortBy('status');
                                        }}
                                        onMouseLeave={() => {
                                            setIconVisible(false);
                                            setSortBy('');
                                        }}
                                        onClick={() => SortData('status')}
                                    >
                                        <div className='flex items-center'>
                                            Payment Status
                                            {iconVisible && sortBy === 'status' ? (
                                                !orderBy.isDecending ? (
                                                    <CaretUpFill className='ms-2' />
                                                ) : (
                                                    <CaretDownFill className='ms-2' />
                                                )
                                            ) : (
                                                <></>
                                            )}
                                        </div>
                                    </button>
                                </td>
                                <td className='w-full text-right'>action</td>
                            </tr>
                        </thead>
                        <tbody className='divide-y border-color'>
                            {transactions?.data?.records?.map((elem, index) => (
                                <tr className='cursor-pointer' key={index} onClick={(e) => {e.stopPropagation(); handleGetOrderData(true, elem)}}>
                                    <td>{`#${elem?.order_id}`}</td>
                                    <td>{formatDate(elem?.order_date, staffInfo?.client) || '-'}</td>
                                    <td>{elem?.products?.reduce((total, product) => total + product.quantity, 0)}</td>
                                    <td>{FormatAmount(elem?.total_price, staffInfo?.client)}</td>
                                    <td>{elem?.user?.name}</td>
                                    <td className='w-full text-right'>
                                        {elem?.returnDetails && elem?.returnDetails?.length > 0 ? <span className={`status-bedge bg-[#fdf4f4] text-[#c9010e]`}>
                                            {elem?.products?.reduce((total, product) => total + product.quantity, 0) === 0  ? 'Return' : 'Partially Return'}
                                        </span> : <span className='flex justify-evenly'>-</span>}
                                    </td>
                                    <td className='w-full text-right'>
                                        <span className={`status-bedge ${elem?.status === 'pending' ? 'text-[#FF8514] bg-[#FFFAF5]' : 'text-[#238823] bg-[#F4FDF5]'}`}>
                                            {elem?.status === 'pending' ? 'Draft' : 'Completed'}
                                        </span>
                                    </td>
                                    <td className='w-full text-right'>
                                        <button
                                            type='button'
                                            className='w-[30px] h-[30px] inline-flex items-center justify-center bg-[#F4FDF5] text-[#238823] border border-[#2388231A] hover:border-[#238823] rounded-full transition-all duration-200'
                                            onClick={(e) => { e.stopPropagation(); handleGetOrderData(true, elem)}}
                                        >
                                            <EyeIcon className='w-4 h-4' />
                                        </button>
                                    </td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                </div>
                :
                <div className='w-full h-auto bg-white flex items-center justify-center border mb-2.5 rounded-[6px] p-5'>
                    No Transaction Found
                </div>
            }
            {transactions?.data ? (
                <div className='bg-white border main-border-color flex flex-1 p-5 items-center justify-between pagination overflow-hidden rounded-[6px]'>
                    <span className='text-sm font-medium'>
                        {limit === 'all'
                            ? `${transactions?.data?.totalRecords}` + ' ' + `records`
                            : `${startRecord} - ${endRecord} of ${transactions?.data?.totalRecords
                            } records`}
                    </span>
                    <div>
                        {transactions?.data?.totalPages !== 1 ? (
                            <Pagination
                                count={transactions?.data?.totalPages}
                                page={Page}
                                onChange={(e, v) => setPage(v)}
                            />
                        ) : (
                            ''
                        )}
                    </div>
                </div>
            ) : (
                <></>
            )}
        </>
    )
}

export default TransactionList